// Angular
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
// RxJS
import {Observable} from 'rxjs';
// CRUD
import {HttpUtilsService, QueryParamsModel, QueryResultsModel} from '../../_base/crud';
// Models
import {AssetClassRetailModel} from '../_models/asset-class-retail.model';
import {environment} from '../../../../environments/environment';
import {AssetClassBuildingInformation, AssetClassTenure, AssetClassSizeModel, OfficeExternalAreaModel} from '..';
import { MadAuthService } from '../../mad-auth/mad-auth.service';
import { SubdomainService } from '../../_base/subdomain.service';
// import {LatLng} from '@agm/core';

const RESIDENTIALS_PATH = 'retails';

@Injectable()
export class AssetClassRetailsService {
    API_COMPARABLES_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/comparable/`;
    constructor(private http: HttpClient, private authService: MadAuthService, private httpUtils: HttpUtilsService, private subDomainService: SubdomainService) {
    }

    findAssetClassRetails(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const httpHeaders = this.authService.getAuthHeaders();
        const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.get<QueryResultsModel>(url, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    getApartments(queryParams: QueryParamsModel): Observable<any> {


        const _body = {
            sortOrder: queryParams.sortOrder,
            sortField: queryParams.sortField,
            page: queryParams.pageNumber.toString(),
            pageSize: queryParams.pageSize.toString(),
            filter: queryParams.filter,
        };
        const httpHeaders = this.authService.getAuthHeaders();
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH + '/data';
        return this.http.post<any>(url, _body, {headers: httpHeaders});
    }

    createAssetClassRetail(_assetClassRetail: AssetClassRetailModel,
                                _tenures: AssetClassTenure[],
                                _sizes: AssetClassSizeModel[],
                                _fileList: any[],
                                _selectedFacilities: any[],
                                _selectedFacilitiesExclusive: any[],
                                _officeExternalAreas: OfficeExternalAreaModel[]): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        const body = {
            assetClassRetail: _assetClassRetail,
            tenures: _tenures,
            sizes: _sizes,
            fileList: _fileList,
            selectedFacilities: _selectedFacilities,
            selectedFacilitiesExclusive: _selectedFacilitiesExclusive,
            officeExternalAreas: _officeExternalAreas
        };
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.post<any>(url, body, {headers: httpHeaders});
    }

    updateAssetClassRetail(_assetClassRetail: AssetClassRetailModel,
                                _tenures: AssetClassTenure[],
                                _sizes: AssetClassSizeModel[],
                                _fileList: any[],
                                _selectedFacilities: any[],
                                _selectedFacilitiesExclusive: any[],
                                _officeExternalAreas: OfficeExternalAreaModel[]): Observable<any> {
        const httpHeader = this.authService.getAuthHeaders();
        httpHeader.set('Content-Type', 'application/json');
        const body = {
            assetClassRetail: _assetClassRetail,
            tenures: _tenures,
            sizes: _sizes,
            fileList: _fileList,
            selectedFacilities: _selectedFacilities,
            selectedFacilitiesExclusive: _selectedFacilitiesExclusive,
            officeExternalAreas: _officeExternalAreas
        };
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.put(url + `/${_assetClassRetail.id}`, body, {headers: httpHeader});
    }

    // Trash
    getTrashedAssetClassRetails(): Observable<any> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.get<AssetClassRetailModel[]>(url + `/trash`);
    }

    // admin Trash
    getAdminTrashedAssetClassRetails(assetClassRetailId: number): Observable<AssetClassRetailModel[]> {
        const url = this.API_COMPARABLES_URL + assetClassRetailId + RESIDENTIALS_PATH;
        return this.http.get<AssetClassRetailModel[]>(url + `/admin/trash`);
    }

    // Trash
    // delete from trash
    deleteFromTrash(assetClassRetailId: number): Observable<any> {

        return this.http.delete<any>(environment.baseApiUrl + `api/${this.subDomainService.subDomain}/comparable/offices` + `/trash/${assetClassRetailId}`);
    }

    // restore from trash
    restoreFromTrash(assetClassRetailId: number): Observable<any> {

        return this.http.get<any>(environment.baseApiUrl + `api/${this.subDomainService.subDomain}/comparable/offices` + `/trash/${assetClassRetailId}`);
    }

    deleteAssetClassRetail(assetClassRetailId: number): Observable<any> {
        const url = `${environment.baseApiUrl}api/${this.subDomainService.subDomain}/comparable/offices/${assetClassRetailId}`;
        return this.http.delete<any>(url);
    }

    flushTrash(): Observable<any> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.get<any>(url + '/trash/flush');
    }

    getAssetClassRetail(assetClassRetailId: number): Observable<AssetClassRetailModel> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;
        return this.http.get<AssetClassRetailModel>(url + `/${assetClassRetailId}`);
    }

    getBuildingInfoById(assetClassRetailId: number): Observable<AssetClassBuildingInformation> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH + `/${assetClassRetailId}/building-information`;
        return this.http.get<AssetClassBuildingInformation>(url);
    }

    getBuildingInfos(): Observable<any> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH + `/building-informations`;
        return this.http.get<any>(url);
    }

    getTenuresOfAc(id: number): Observable<any> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH + `/${id}/tenures`;
        return this.http.get<any>(url);
    }

    getSizesOfAc(id: number): Observable<any> {
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH + `/${id}/sizes`;
        return this.http.get<any>(url);
    }


    getApartmentsByLocation(latLng1: google.maps.LatLng, latLng2: google.maps.LatLng): Observable<any> {
        const httpHeader = this.authService.getAuthHeaders();
        httpHeader.set('Content-Type', 'application/json');
        const body = {
            max_lng: latLng2.lng(),
            max_lat: latLng2.lat(),
            min_lng: latLng1.lng(),
            min_lat: latLng1.lat(),
        };
        const url = this.API_COMPARABLES_URL + RESIDENTIALS_PATH;

        return this.http.post(url + `/map`, body, {headers: httpHeader});
    }
}
